import { apiClient } from "@vv/api";
import type {
  AddTeamMemberRequest,
  CreateTeamRequest,
  Team,
  TeamMember,
  TeamRole,
  UpdateTeamRequest,
} from "../domain/team.types";

export const teamsApi = {
  list: () => apiClient.get<Team[]>("/teams"),

  get: (teamId: string) => apiClient.get<Team>(`/teams/${teamId}`),

  create: (payload: CreateTeamRequest) => apiClient.post<Team>("/teams", payload),

  update: (teamId: string, payload: UpdateTeamRequest) =>
    apiClient.patch<Team>(`/teams/${teamId}`, payload),

  listMembers: (teamId: string) => apiClient.get<TeamMember[]>(`/teams/${teamId}/members`),

  listMyMemberships: () => apiClient.get<TeamMember[]>("/teams/my-memberships"),

  addMember: (teamId: string, payload: AddTeamMemberRequest) =>
    apiClient.post<TeamMember>(`/teams/${teamId}/members`, payload),

  removeMember: (teamId: string, userId: string, role: TeamRole) =>
    apiClient.delete<void>(`/teams/${teamId}/members/${userId}/${role}`),
};
